import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import Offcanvas from "react-bootstrap/Offcanvas";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import {
  addGaonProducts,
  getGaonProducts,
  getProductsByGaonId,
  deleteGaonProduct,
} from "../../action/gaonApi";
import uploadImage from "../../action/imageUpload";
import ThumbnailPicker from "../../components/ThumbnailPicker/ThumbnailPicker";
import { getImageUrl } from "../../helper/constants";
import showNotification from "../notification/showNotification";
import { Button, Modal } from "react-bootstrap";
import trashIcon from "../../assets/images/trash-03.svg";

const ProductManagement = ({ gaonId }) => {
  // State for dropdown products and product list
  const [dropdownProducts, setDropdownProducts] = useState([]);
  const [productList, setProductList] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  // Fetch dropdown products
  const productsDropdown = async () => {
    const res = await getGaonProducts();
    if (res.status) {
      setDropdownProducts(res.data?.list);
    }
  };

  // Fetch product list
  const getProductList = async () => {
    const res = await getProductsByGaonId(gaonId);
    if (res.status) {
      setProductList(res.data?.list);
    }
  };

  const uploadMediaImage = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await uploadImage(formData, "gaon");
    if (res.status) {
      formik.setFieldValue("pic", res.data[0]);
    }
  };

  // Initialize data
  useEffect(() => {
    productsDropdown();
    getProductList();
  }, [gaonId]);

  // Formik form configuration
  const formik = useFormik({
    initialValues: {
      pic: "",
      parentId: "",
      name: "",
    },
    onSubmit: async (values) => {
      const payload = {
        ...values,
        gaonId: gaonId,
      };

      // Here you would typically call your API to submit the form
      const res = await addGaonProducts(payload);
      if (res.status) {
        getProductList(); // Refresh the list
        setShowForm(false); // Close the form
        formik.resetForm(); // Reset form
      }

      console.log("Form submitted:", payload);
      // For demo purposes, we'll just close the form and reset
      setShowForm(false);
      formik.resetForm();
    },
    validate: (values) => {
      const errors = {};
      if (!values.name) errors.name = "Required";
      if (!values.parentId) errors.parentId = "Required";
      return errors;
    },
  });

  // Delete product
  const removeProduct = async (productId) => {
    const res = await deleteGaonProduct(productId);
    if (res.status) {
      setShowDeleteModal(false);
      getProductList();
      showNotification("Gaon Details", res?.message, "success");
    } else {
      showNotification("Gaon Details", res?.message, "danger");
    }
  };

  return (
    <div className="payout_data-content tablePage_content_header mt-3 mb-3">
      <div className="address_section">
        <div className="address_div">
          <div className="address_label">
            <h4>Products</h4>
            <div>
              <Button variant="primary" onClick={() => setShowForm(true)}>
                Add Product
              </Button>
            </div>
          </div>

          <div className="address_option">
            <table className="payout_table upi-mandate_table">
              <thead>
                <tr className="tableHead">
                  <th className="thHeader">Image</th>
                  <th className="thHeader">Name</th>
                  <th className="thHeader">Type</th>
                  <th className="thHeader">Action</th>
                </tr>
              </thead>
              <tbody>
                {productList && productList.length > 0 ? (
                  productList.map((product) => (
                    <tr key={product._id}>
                      <td>
                        {product.pic && (
                          <img
                            src={getImageUrl(product.pic)}
                            alt={product.name}
                            style={{
                              width: "50px",
                              height: "50px",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </td>
                      <td>{product.name}</td>
                      <td>{product?.parentId?.name}</td>
                      <td>
                        <button
                          className="action_btn1"
                          onClick={() => {
                            setProductToDelete(product);
                            setShowDeleteModal(true);
                          }}
                        >
                          <img src={trashIcon} alt="delete" />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <>
                    <tr>
                      <td colspan="11" className="text_center">
                        No data found
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
          {/* OffCanvas Form */}
          <Offcanvas
            show={showForm}
            onHide={() => {
              formik.handleReset();
              setShowForm(false);
            }}
            placement="end"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Add New Product</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <div className="px-3">
                <Form onSubmit={formik.handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Product Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={formik.touched.name && formik.errors.name}
                      placeholder="Enter product name"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Parent Product</Form.Label>
                    <Form.Select
                      name="parentId"
                      value={formik.values.parentId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        formik.touched.parentId && formik.errors.parentId
                      }
                    >
                      <option value="">Select a parent product</option>
                      {dropdownProducts.map((product) => (
                        <option key={product._id} value={product._id}>
                          {product.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.parentId}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Product Image</Form.Label>
                    <ThumbnailPicker
                      width="auto"
                      height="250px"
                      onFileSelect={(file) => {
                        const _URL = window.URL || window.webkitURL;

                        const img = new Image();
                        uploadMediaImage(file);

                        img.src = _URL.createObjectURL(file);
                      }}
                      image={formik.values?.pic}
                      accept={"image/*"}
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="btn btn-success"
                  >
                    Add Product
                  </Button>
                </Form>
              </div>
            </Offcanvas.Body>
          </Offcanvas>

          {/* Delete Confirmation Modal */}
          <Modal
            show={showDeleteModal}
            onHide={() => setShowDeleteModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete the product "
              {productToDelete?.name}"?
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                className="btn btn-dark"
                onClick={() => removeProduct(productToDelete?._id)}
              >
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default ProductManagement;
